import axios from 'axios'
import {host} from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    puestos: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const OBTENER_DATOS_GET_PUESTOS_EXITO= 'OBTENER_DATOS_GET_PUESTOS_EXITO'
//*******************************************************************************************************************




//MÉTODOS 
export const getPuestos = createAsyncThunk(
    OBTENER_DATOS_GET_PUESTOS_EXITO,
    async () => {
        try {
            const fullUrl = host + `Puestos/obtenerPuestos`
            const res = await axios.get(fullUrl)
            console.log('Se obtienen Puestos: '+res)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)



//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosPuestoSlice = createSlice({

    name: 'metodosPuestoSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
      
        [getPuestos.fulfilled]: (state, { payload }) => {
            state.puestos = payload.data.data
        }
       
    },

})


export const {} = metodosPuestoSlice.actions
export const PuestoReducer = metodosPuestoSlice.reducer